import LS from '../styles/layoutStyled';
import CS from '../styles/componentStyled';
import { ReactNode } from 'react';

interface InputModalProps {
  title: string;
  subText?: string;
  children: ReactNode;
  onCancel: () => void;
  onConfirm?: () => void;
  onlyView?: boolean;
  onlyConfirm?: boolean;
  isFullScreen?: boolean;
}

const InputModal = ({
  title,
  subText,
  children,
  onCancel,
  onConfirm,
  onlyView,
  onlyConfirm,
  isFullScreen = false,
}: InputModalProps) => {
  return (
    <>
      <LS.ModalBg>
        <CS.ModalBoxType1 className={isFullScreen ? 'full-screen' : ''}>
          <h1>{title}</h1>
          {subText && <p>{subText}</p>}
          {children}
          {!onlyView && !onlyConfirm && (
            <div className="btn-box">
              <CS.Btn2Type2 type="button" onClick={onCancel}>
                취소
              </CS.Btn2Type2>
              <CS.Btn2Type1 type="button" onClick={onConfirm}>
                확인
              </CS.Btn2Type1>
            </div>
          )}
          {onlyView && (
            <div className="btn-box">
              <CS.Btn2Type2 type="button" onClick={onCancel}>
                닫기
              </CS.Btn2Type2>
            </div>
          )}
          {onlyConfirm && (
            <div className="btn-box">
              <CS.Btn2Type1 type="button" onClick={onConfirm}>
                확인
              </CS.Btn2Type1>
            </div>
          )}
        </CS.ModalBoxType1>
      </LS.ModalBg>
    </>
  );
};

export default InputModal;
